import React from 'react'

export const Bold = ({ children }) => {
  return <strong className='font-bold'>{children}</strong>
}
